import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import "./adminHomepage.css";
import axios from "axios";
import { Box, TextField, Button,Typography,Autocomplete, Chip, CircularProgress, MenuItem, AppBar, Toolbar, ListItemText} from "@mui/material";
import NMH_LOGO_White_RGB from '../Assets/NMH_LOGO_White_RGB.png';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import UserToolbar from "./UserToolbar";

const SavedEventsPage = () => {
  const [events, setEvents] = useState([]);
  const [categories, setCategories] = useState([]);
  const [sortBy, setSortBy] = useState("");
  const [loading, setLoading] = useState(false);
  // const [postingTypes, setPostingTypes] = useState([]);
  const [selectedMode, setSelectedMode] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  // const [selectedPostingTypes, setSelectedPostingTypes] = useState([]);
  const [ savedPostIds, setsavedPostIds] = useState([]);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  const sortOptions = [
    // { label: "Recently Added", value: "recent" },
    { label: "New to Old", value: "newToOld" },
    { label: "Old to New", value: "oldToNew" },
  ];

  const [userName, setUsername] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState();
  const [userType, setUserType] = useState("");

  const logoutAll = async () => {
  try {
      await axios.post(`${API_BASE_URL}/api/auth/logout`, {}, { withCredentials: true });
      localStorage.clear();
      sessionStorage.clear();

      const googleLogoutWindow = window.open(`https://accounts.google.com/logout`, '_blank');
      setTimeout(() => {
          if (googleLogoutWindow) googleLogoutWindow.close(); 
          navigate('/login'); 
      }, 3000);
  } catch (error) {
      console.error('Logout failed:', error.message);
  }
};

  const fetchPosts = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/isLoggedIn`, {
        withCredentials: true,
      });
      if (response.data.username) {
        setUsername(response.data.username);
        setIsLoggedIn(true);
        setUserType(response.data.user);
      } else {
        setIsLoggedIn(false);
        navigate("/login");
      }
        const { user, username } = response.data;
        if ( user === 'User'|| user === 'Editor' || user === 'Admin') {
        //   setUserType(user);
          setUsername(username);
           const savedRes = await axios.get(`${API_BASE_URL}/api/likePostByUser/${username}`);
        // setSavedEvents(savedRes.data);
        setsavedPostIds(savedRes.data.map(event => event.postId._id));
        setEvents(savedRes.data);
        } 
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    // fetchFilters();
    fetchPosts();
    // getUsernamefromCookie();
  }, []);

  const bookmarkEvent = async (postId) => {
  try {
    setsavedPostIds((prev) => [...prev, postId]);

    const payload = {
      emailId: userName,    
      postId: postId
    };
    await axios.post(`${API_BASE_URL}/api/likePostByUser`, payload);
     const savedPostsbyUser= await axios.post(`${API_BASE_URL}/api/savedPostsByUser`,{userName});
    setsavedPostIds(savedPostsbyUser.data.map(event => event.postId._id));  } 
    catch (error) {
    console.error("Error saving post:", error);
    setsavedPostIds((prev) => prev.filter((id) => id !== postId));
  }
};

  const unsave = async (postId) => {
  try {
    setsavedPostIds((prev) => prev.filter((id) => id !== postId));

    const payload = {
      userName,    
      postId: postId
    };
  await axios.delete(`${API_BASE_URL}/api/unsavePost`, {data: payload,  headers: { 'Content-Type': 'application/json' }
    });
   const savedPostsbyUser= await axios.post(`${API_BASE_URL}/api/savedPostsByUser`,{userName});
    setsavedPostIds(savedPostsbyUser.data.map(event => event.postId._id));  
  } catch (error) {
    console.error("Error unsaving post:", error);
    setsavedPostIds((prev) => [...prev, postId]);
  }
};

  return (
    <Box sx={{ width: "100%", padding: 0, margin: 0 }}>
      {
      isLoggedIn
       && userName 
       ? 
      (
        <>
          <div className="form-container-1">
            <Box sx={{ width: "100%", borderColor: "divider" }}>
              <Typography
                sx={{ textAlign: "center", fontWeight: "bold", mb: 1 }}
              >
                Saved Events
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  flexWrap: "wrap",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
             {/* <Autocomplete
                multiple
                id="Category"
                options={categories}
                value={selectedCategories} 
                onChange={(event, newValue) => setSelectedCategories(newValue)}
                renderInput={(params) => (
                  <TextField {...params} label="Category" variant="outlined" />
                )}
                sx={{ width: 250 }}
              />

              <Autocomplete
                multiple
                id="PostingType"
                options={postingTypes}
                value={selectedPostingTypes} 
                onChange={(event, newValue) => setSelectedPostingTypes(newValue)}
                renderInput={(params) => (
                  <TextField {...params} label="Posting Type" variant="outlined" />
                )}
                sx={{ width: 250 }}
              /> */}


              {/* 

              <Autocomplete
                disablePortal
                id="Mode"
                options={modes}
                value={selectedMode || null}
                onChange={(event, newValue) => setSelectedMode(newValue || "")}
                renderInput={(params) => (
                  <TextField {...params} label="Mode" variant="outlined" />
                )}
                sx={{ width: 250 }}
              /> */}

                {/* <Autocomplete
                  disablePortal
                  id="SortBy"
                  options={sortOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    sortOptions.find((opt) => opt.value === sortBy) || null
                  }
                  onChange={(event, newValue) =>
                    setSortBy(newValue ? newValue.value : "")
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Sort By" variant="outlined" />
                  )}
                  sx={{ width: 250 }}
                /> */}
              </Box>

              {/* <Box
                sx={{
                  padding: 4,
                  display: "flex",
                  gap: 2,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button variant="contained" color="primary" onClick={applyFilters}>
                  Apply Filters
                </Button>
                <Button variant="outlined" onClick={clearSelection}>
                  Clear Selection
                </Button>
              </Box> */}

              {loading ? (
                <div className="loading-container">
                  <CircularProgress />
                </div>
              ) : (
                <Box>
                  <div className="event-list-container">
                    {/* {events.map((event, index) => ( */}
                    {events.map((savedPost, index) => {
  const event = savedPost.postId;
  if (!event) return null; 

  return (
    <div key={index} className="event-card-horizontal">
      {/* {event.eventImage ? (
        <img
          src={event.eventImage}
          alt={event.eventName}
          className="event-thumbnail-homepage"
        />
      ) : (
        <div className="event-thumbnail-homepage"></div>
      )} */}
      <div className="event-content">
        <Typography
          variant="h6"
          className="event-title"
          onClick={() => navigate(`/event/${event._id}`)}
        >
          {event.eventName}
        </Typography>
        <Typography variant="body2" className="event-datetime">
          {new Date(event.postStartDate).toLocaleDateString("en-US", {
            weekday: "short",
            year: "numeric",
            month: "long",
            day: "numeric",
          })}{" "}
          · {event.mode}
        </Typography>
        <div className="event-tags">
          {event.categories?.map((type, i) => (
            <Chip
              key={i}
              label={type}
              className="posting-type-chip"
              onClick={() => {
                setSelectedCategories((prev) => {
                  if (prev.includes(type)) return prev;
                  return [...prev, type];
                });
                // applyFilters();
              }}
              style={{ cursor: "pointer" }}
            />
          ))}
        </div>
        <Typography variant="body2" className="event-description">
          {event.description?.length > 200
            ? `${event.description.substring(0, 200)}...`
            : event.description}
        </Typography>
         <Typography variant="body2" className="event-read-more">
                      {savedPostIds.includes(event._id) ? (
                        <BookmarkIcon onClick={() => unsave(event._id)}  />
                      ) : (
                        <BookmarkBorderIcon onClick={() => bookmarkEvent(event._id)} />
                      )}
          </Typography>
      </div>
    </div>
  );
})}

                  </div>
                </Box>
              )}
            </Box>
          </div>
        </>
      ) : (
        <h4>Checking authentication...</h4>
      )}
    </Box>
  );
};

export default SavedEventsPage;